<script>

	import Question from '@/components/Question/Question'

	import './style.scss'

	export default {
		name: 'questions',
		props: [
			'questions'
		],
		components: {
			Question,
		},
		computed: {
			formattedQuestions () {
				return _.orderBy(this.questions, ['title'], ['desc'])
			}
		}
	}

</script>

<template>
	<div class='questions'>
		<div class='question-header'>
			<div class='question-title'>
				Title
			</div>
			<div class='last-asked'>
				Asked
			</div>
			<div class='frequency'>
				Frequency
			</div>
		</div>
		<Question
			v-for='question in formattedQuestions'
			:key='question.title'
			:title='question.title'
			:question='question.question'
			:lastAsked='question.metadata.lastAsked'
			:frequency='question.metadata.frequency'
		/>
	</div>
</template>



// WEBPACK FOOTER //
// src/components/Questions/Questions.vue